const loadingLabel = "A carregar";
const ptPT = {
  loadingLabel
};
export {
  ptPT as default,
  loadingLabel
};
